/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import List from './List/BroadcastList';
import { withRoomContext } from '../../../RoomContext';
import { connect } from 'react-redux';
import BroadcastInput from './Menu/BroadcastInput';
import { setWebinarData } from '../../../store/actions/webinarActions';
import * as roomActions from '../../../store/actions/roomActions';
import { FormattedMessage } from 'react-intl';
import * as chartActions from '../../../store/actions/chatActions';

const styles = () =>
	({
		root :
		{
			display       : 'flex',
			flexDirection : 'column',
			width         : '100%',
			height        : '100%',
			overflowY     : 'auto'
		}
	});

const BroadcastChat = (props) =>
{
	const {
		broadcastMessage,
		roomClient,
		classes,
		webinarUser,
		sessionId,
		handleClose,
		webinarData,
		webinarStreamOn,
		isPlaying,
		setIsPlaying,
		setRemoveCount, preview, setPreview, setFileUrl, fileUrl
	} = props;

	const [ replyData, setReplyData ]=useState(null);

	console.log('broadcastMessage', broadcastMessage, replyData);

	useEffect(() =>
	{
		if ((webinarData?.chat === false || webinarStreamOn === false) && handleClose)
		{
			handleClose();
		}
	}, [ webinarData?.chat === false, webinarStreamOn === false ]);

	useEffect(() =>
	{
		const handleBackButton = (event) =>
		{
			handleClose();
		};

		// listener for the popstate event
		window.history.pushState(null, '', window.location.href);

		window.addEventListener('popstate', handleBackButton);

		if (broadcastMessage.length === 0)
		{
			roomClient.getLiveBroadcastChat(sessionId);
		}

		return () =>
		{

			// console.log('COMPONNENT INMOUNTEDDD')
			window.removeEventListener('popstate', handleClose);
		};
	}, []);

	useEffect(() =>
	{
		setRemoveCount();
	}, [ broadcastMessage ]);

	return (
		<Paper className={classes.root}>
			{Object.keys(fileUrl || {})?.length === 0 && webinarUser && <div className='flexRow aCntr pdngXS jBtwn pRel'>
				<div className='flexAutoCol'>
					<img className='pointer icons' src='icons/close.svg' alt='close' onClick={handleClose} />
				</div>

				<div className='flexMinWidthCol'>
					<span className='mHdng ellipse tCntr' >
						<b>
							<FormattedMessage
								id='label.chat'
								defaultMessage='Chat'
							/>
						</b>
					</span>
					{/* <span className='mHdng ellipse tCntr' ><b>{MeetingName}</b></span> */}
				</div>
			</div>}
			<List isPlaying={isPlaying} setIsPlaying={setIsPlaying} webinarUser={webinarUser} replyData={replyData} setReplyData={setReplyData} preview={preview} setPreview={setPreview} setFileUrl={setFileUrl} fileUrl={fileUrl} />
			{/* <Input /> */}
			{/* <InputNew/> */}
			{Object.keys(fileUrl || {})?.length === 0 && <BroadcastInput webinarUser={webinarUser} replyData={replyData} setReplyData={setReplyData} />}
		</Paper>
	);
};

BroadcastChat.propTypes =
{
	broadcastMessage : PropTypes.array,
	classes          : PropTypes.object,
	roomClient       : PropTypes.any,
	webinarUser      : PropTypes.any,
	sessionId        : PropTypes.any,
	handleClose      : PropTypes.func,
	webinarData      : PropTypes.any,
	webinarStreamOn  : PropTypes.any,
	isPlaying        : PropTypes.any,
	setIsPlaying     : PropTypes.any,
	setRemoveCount   : PropTypes.func,
	preview          : PropTypes.any,
	setPreview       : PropTypes.any,
	fileUrl          : PropTypes.any,
	setFileUrl       : PropTypes.any
};

const makeMapStateToProps = () =>
{
	const mapStateToProps = (state) =>
		({
			webinarData      : state.webinar.webinarData,
			broadcastMessage : state.chat.broadcastMessage,
			webinarStreamOn  : state.room.webinarStreamOn
		});

	return mapStateToProps;

};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setData : (webinarData) =>
		{
			dispatch(setWebinarData(webinarData));
		},
		setStream : (streamVal) =>
		{
			dispatch(roomActions.setWebinarStreamOn({ webinarStreamOn: streamVal }));
		},
		setRemoveCount : () =>
		{
			dispatch(chartActions.removeBroadcastCount());
		}

	};
};

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.webinar.webinarData === next.webinar.webinarData &&
				prev.room.webinarStreamOn === next.room.webinarStreamOn &&
				prev.chat.broadcastMessage === next.chat.broadcastMessage
			);
		}
	}
)(withStyles(styles)(BroadcastChat)));
